// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getAllDataGroupeCatalogs = createAsyncThunk('appUsers/getAllDataGroupeCatalogs', async (id) => {
  const response = await axios.get('https://apiv3.opentlv.com/api/v3/groupe/catalogs/all', { params: { id} })
  return response.data
})

export const getDataGroupeCatalogs = createAsyncThunk('appUsers/getDataGroupeCatalogs', async params => {
  const response = await axios.get('https://apiv3.opentlv.com/api/v3/groupe/catalogs/data', {params})
  return {
    params,
    data: response.data.data,
    totalPages: response.data.total
  }
})

export const getUser = createAsyncThunk('appUsers/getUser', async id => {
  const response = await axios.get('https://apiv3.opentlv.com/api/v3/users/user', { params: { id} })
  console.log(response.data)
  return response.data
})

export const addUser = createAsyncThunk('appUsers/addUser', async (user, { dispatch, getState }) => {
  await axios.post('/apps/users/add-user', user)
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return user
})

export const deleteUser = createAsyncThunk('appUsers/deleteUser', async (id, { dispatch, getState }) => {
  await axios.delete('/apps/users/delete', { id })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return id
})

export const addCatalog = createAsyncThunk('appUsers/addCatalog', async (catalog, { dispatch, getState }) => {


  await axios.post('https://apiv3.opentlv.com/api/v3/groupe/addcatalog', catalog)

  //await dispatch(getAllDataSitesClient(getState().sitesClient.params.id))
  await dispatch(getDataGroupeCatalogs(getState().catalogsGroupe.params))

  return site
})

export const deleteCatalog = createAsyncThunk('appUsers/deleteCatalog', async (id, { dispatch, getState }) => {
  console.log("getState()")
  console.log(id)

  await axios.delete('https://apiv3.opentlv.com/api/v3/groupe/catalog/delete', {params: {id}})
//  await dispatch(getData(getState().users.params))
    await dispatch(getDataGroupeCatalogs(getState().catalogsGroupe.params))

  return id

})
export const appClientsSlice = createSlice({
  name: 'appUsers',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllDataGroupeCatalogs.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getDataGroupeCatalogs.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })
  }
})

export default appClientsSlice.reducer
